import translatorMixin from "./translatorMixin";

/**
 *
 * @param key
 * @param returnKeyIfMissing
 * @param args Arguments to replace in the translation string, placeholder in translation cannot have any whitespace inside {}. E.g. must be "Hello {name}" not "Hello { name }".
 */
export function translate(key: string, returnKeyIfMissing: boolean = false, args: Array<number | string> = []) {
    return translatorMixin.methods.translate(key, returnKeyIfMissing, args);
}
